import {
    REQUEST_AGENTS,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE,
    SELECT_AGENT,
    RESET_CURRENT_AGENT,
    REQUEST_CREATING_AGENT,
    CREATE_AGENT_SUCCESS,
    CREATE_AGENT_FAILURE,
    REQUEST_EDITING_AGENT,
    EDIT_AGENT_SUCCESS,
    EDIT_AGENT_FAILURE,
    REQUEST_AGENT_DETAIL,
    FETCH_AGENT_DETAIL_SUCCESS,
    FETCH_AGENT_DETAIL_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentAgent: null,
    currentAgentDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_AGENTS:
            return { ...state, error: null, isLoading: true };
        case FETCH_AGENTS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_AGENTS_FAILURE:
            const error = action.payload || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_AGENT:
            return { ...state, currentAgent: action.payload };
        case RESET_CURRENT_AGENT:
            return { ...state, currentAgent: null, currentAgentDetail: null };
        case REQUEST_CREATING_AGENT:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_AGENT_SUCCESS:
            return { ...state, isCreating: false, createError: null, created: true };
        case CREATE_AGENT_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false };
        case REQUEST_EDITING_AGENT:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_AGENT_SUCCESS:
            return { ...state, isEditing: false, editError: null, edited: true };
        case EDIT_AGENT_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };
        case REQUEST_AGENT_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_AGENT_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentAgentDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_AGENT_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/agents_reducer.js